/*
 * @Date: 2024-01-04 15:36:58
 * @LastEditors: puxue
 * @LastEditTime: 2024-04-03 15:17:26
 */
export default [
  {
    path: '/rent/v2/carBusiness/index',
    name: 'carBusinessIndex',
    component: () => import('@/pages/carBusiness/index'),
    meta: { title: '房车买卖', requireAuth: true },
  },
  {
    path: '/rent/v2/carBusiness/search',
    name: 'carBusinessSearch',
    component: () => import('@/pages/carBusiness/search'),
    meta: { title: '房车买卖搜索', requireAuth: true },
  },
  {
    path: '/rent/v2/carBusiness/saleSearch',
    name: 'saleSearch',
    component: () => import('@/pages/carBusiness/saleSearch'),
    meta: { title: '资讯搜索', requireAuth: true },
  },
]


// WEBPACK FOOTER //
// ./src/pages/carBusiness/carBusiness.js